import { useState, useEffect } from "react";
import { onAuthChange, logout as authLogout, AuthUser } from "../firebase/auth";
import { UserRole } from "../constants";

const USER_CACHE_KEY = "natura_auth_user";

export function useAuth() {
  // ✅ Initialiser avec le cache localStorage
  const [user, setUser] = useState<AuthUser | null>(() => {
    try {
      const cached = localStorage.getItem(USER_CACHE_KEY);
      return cached ? JSON.parse(cached) : null;
    } catch {
      return null;
    }
  });
  
  // ✅ Si on a un user en cache, on n'est pas en loading
  const [loading, setLoading] = useState(() => {
    try {
      const cached = localStorage.getItem(USER_CACHE_KEY);
      return !cached; // Loading uniquement si pas de cache
    } catch {
      return true;
    }
  });

  useEffect(() => {
    const unsubscribe = onAuthChange((authUser) => {
      setUser(authUser);
      setLoading(false);
      
      // ✅ Cacher le user dans localStorage
      if (authUser) {
        localStorage.setItem(USER_CACHE_KEY, JSON.stringify(authUser));
      } else {
        localStorage.removeItem(USER_CACHE_KEY);
      }
    });

    return unsubscribe;
  }, []);

  const logout = async () => {
    await authLogout();
    setUser(null);
    localStorage.removeItem(USER_CACHE_KEY);
  };

  const hasRole = (role: UserRole): boolean => {
    return user?.role === role;
  };

  const hasAnyRole = (roles: UserRole[]): boolean => {
    return roles.some((role) => user?.role === role);
  };

  return {
    user,
    loading,
    isAuthenticated: !!user,
    logout,
    hasRole,
    hasAnyRole,
  };
}

